// Client-side Sentry initialization for @sentry/nextjs v8.
//
// This file is auto-injected into the client bundle by withSentryConfig
// (see next.config.js). It runs once at the very start of the browser
// bundle, before _app.tsx evaluates. The Sentry plugin never injects
// this into the server bundle, so browser-only APIs are safe to call
// here without a `typeof window` guard.
//
// Server/edge initialization lives in instrumentation.ts +
// sentry.server.config.js / sentry.edge.config.js.

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"twycA-zvoAxx2pQPnLuRl"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';
import moment from 'moment';

import config from './src/config';
import getScreenshot, { ScreenshotType } from './src/utils/screenshot';

const attachmentUrlFromDsn = (dsn, eventId) => {
  const { host, path, projectId, port, protocol, user } = dsn;

  return `${protocol}://${host}${port !== '' ? `:${port}` : ''}${
    path !== '' ? `/${path}` : ''
  }/api/${projectId}/events/${eventId}/attachments/?sentry_key=${user}&sentry_version=7&sentry_client=custom-javascript`;
};

if (config.get('sentry.enabled')) {
  Sentry.init({
    dsn: config.get('sentry.dsn'),
    environment: config.get('sentry.environment'),
    enabled: process.env.NODE_ENV === 'production',
    debug: config.get('sentry.debug'),
    attachStacktrace: config.get('sentry.attachStacktrace'),
    integrations: [
      Sentry.browserTracingIntegration({
        // v7 used `beforeNavigate`, which only fired on navigation/pageload transactions.
        // v8's `beforeStartSpan` fires for every span the integration creates, so gate
        // on op to preserve the v7 behavior of only renaming navigation/pageload spans.
        beforeStartSpan(spanContext) {
          if (spanContext.op === 'navigation' || spanContext.op === 'pageload') {
            return {
              ...spanContext,
              name: window.route || spanContext.name,
            };
          }

          return spanContext;
        },
      }),
    ],
    release: 'built at: ' + config.get('builtAt'),
    tracesSampleRate: config.get('sentry.tracesSampleRate'),
    ignoreErrors: [
      // https://github.com/getsentry/sentry-javascript/issues/2546
      'Non-Error exception captured',
      'Non-Error promise rejection captured with keys',

      // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
      'ResizeObserver loop limit exceeded',

      "Failed to read the 'sessionStorage' property from 'Window'",
      'SecurityError: The operation is insecure',
      'Request failed with status code 401',
      'Attempt to use history.replaceState() more than 100',
    ],
  });

  if (config.get('sentry.screenshots')) {
    // Use the global scope explicitly to preserve v7's `addGlobalEventProcessor`
    // semantics — the v8 top-level `Sentry.addEventProcessor` adds to the
    // current isolation scope, which is more localized.
    Sentry.getGlobalScope().addEventProcessor(async (event) => {
      const screenshot = await getScreenshot(undefined, undefined, ScreenshotType.Blob);

      if (!screenshot) {
        return;
      }

      try {
        const client = Sentry.getClient();

        if (!client) {
          return event;
        }

        const endpoint = attachmentUrlFromDsn(client.getDsn(), event.event_id);
        const formData = new FormData();

        formData.append('image', screenshot, `screenshot-${moment().format('DD.MM.YYYY-HH:mm:ss')}.jpg`);
        fetch(endpoint, {
          method: 'POST',
          body: formData,
        }).catch((ex) => {
          // we have to catch this otherwise it throws an infinite loop in Sentry
          console.error(ex);
        });

        return event;
      } catch (ex) {
        console.error(ex);

        return event;
      }
    });
  }
}
